import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();

  return (
    <nav className="w-full px-2 py-1" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center text-sm text-gray-500 space-x-2">
        {items.map((item, index) => (
          <li key={index} className="flex items-center max-w-[200px]">
            {/* Divider */}
            {index > 0 && (
              <svg
                className="w-3 h-3 text-gray-500 mx-1 shrink-0"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 9l4-4-4-4"
                />
              </svg>
              // <IoIosArrowForward size={16} />
            )}

            {/* Label */}
            {item?.path ? (
              <span
                onClick={() => navigate(item.path)}
                title={item.label}
                className="cursor-pointer text-base text-gray-800 font-inter tracking-[0.20px] hover:text-blue-600 font-semibold truncate max-w-full underline"
              >
                {item.label}
              </span>
            ) : (
              <span
                title={item?.label}
                className="text-gray-700 dark:text-gray-300 font-medium truncate max-w-full"
              >
                {item?.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
